export const ActionTypes = {
    PROCEED: 0,
    BOOK: 1,
    DO_NOT_USE: 2,
    EXIT_DROP_IN_CARE: 3,
    EXIT_DROP_IN_OR_BOOK: 4,
    EXIT_BOOK_CONSULT: 5,
    EXIT_OUT_OF_NZ: 6,
    EXIT_EMERGENCY: 7,
    EXIT_NEEDS_SMEAR: 8,
    EXIT_OPEN_WOUND: 9
};
